
define('text!modules/map/map_image_template.html',[],function () { return '<% if (has_map) { %>\r\n  <img src="<%- url %>" alt="">\r\n<% } else { %>\r\n  <img src="/images/map-empty.jpg" alt="">\r\n<% } %>\r\n';});

